import { createContext } from 'react';
/**
 * Height of host chrome overlaying the top of the viewport, which popovers must
 * stay clear of.
 *
 * Placement resolves against the viewport, which assumes window chrome is laid
 * out inside the document. A host that composites its chrome over the document
 * instead — a title bar hosted in a sibling view, say — has viewport space that
 * looks free but is not: the overlaying surface takes the pointer input, so a
 * popover placed there paints normally and receives nothing.
 */
export const PopoverCollisionTopInsetContext = createContext(undefined);
PopoverCollisionTopInsetContext.displayName = 'AetherPopoverCollisionTopInsetContext';
//# sourceMappingURL=context.js.map